import { ReactNode } from 'react';
import { Decimal } from 'decimal.js';
import { useFormatAmount } from '../../../../hooks/decimal-hooks';
import type { DecimalFormatterProps } from '../types/editor-config';

function formatValue(value: unknown, formatAmount: (d: Decimal) => string): string {
  if (value instanceof Decimal) return formatAmount(value);
  if (typeof value === 'number' && Number.isFinite(value)) {
    return formatAmount(new Decimal(value));
  }
  if (typeof value === 'string') {
    try {
      return formatAmount(new Decimal(value));
    } catch {
      return value;
    }
  }
  return String(value);
}

export function DecimalFormatter({ value, currencyCode }: DecimalFormatterProps): ReactNode {
  const formatAmount = useFormatAmount(currencyCode);
  return (
    <span className='inline-flex flex-col gap-2xs items-start'>
      <span>{formatValue(value, formatAmount)}</span>
    </span>
  );
}
